// configuration
import { preStartupHandler, errorsHandler } from "@etab/handlers";

/**
 * Etab boot for specific rules and actions
 */
export default async ({ app, router }) => {
  await errorsHandler({ app, router });
  await preStartupHandler({ app, router });
};
